<template>
  <div class="consult-container">
    <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
    <div class="tabs-container">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabs">
        <el-tab-pane label="应用开通" name="0"></el-tab-pane>
        <el-tab-pane label="实例资源" name="1"></el-tab-pane>
        <el-tab-pane label="服务接入" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-container">
      <el-form
        v-if="activeName === '0'"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="选择日期">
          <el-date-picker
            v-model="formInline.startTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input v-model="formInline.serveName" placeholder="请输入服务商"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-form
        v-else-if="activeName === '1' || activeName === '2'"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="选择日期">
          <el-date-picker
            v-model="formInline.startTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="用户">
          <el-input v-model="formInline.memberName" placeholder="请输入用户"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-loading="tableLoading" class="table-container">
      <!-- 应用开通table -->
      <el-table
        v-if="activeName === '0'"
        key="0"
        :data="tableData"
        :pagination="pagination"
        border
        style="width: 100%"
      >
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{
              (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="enterpriseName" align="center" label="企业名称">
        </el-table-column>
        <!-- <el-table-column prop="memberName" label="用户" align="center">
        </el-table-column> -->
        <el-table-column prop="appName" label="应用名称" align="center">
        </el-table-column>
        <el-table-column prop="startTime" label="交易时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.startTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="serverName" align="center" label="服务商">
        </el-table-column>

        <el-table-column prop="appPrice" align="center" label="应用价格（元）">
        </el-table-column>
        <el-table-column prop="receiveMoney" align="center" label="合同金额（元）">
        </el-table-column>
        <!--  <el-table-column prop="payStatus" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.payStatus === 0">未支付</span>
            <span v-else-if="scope.row.payStatus === 1">已支付</span>
            <span v-else-if="scope.row.payStatus === 2">试用中</span>
            <span v-else-if="scope.row.payStatus === 3">试用已到期</span>
            <span v-else-if="scope.row.payStatus === 4">待审核</span>
            <span v-else-if="scope.row.payStatus === 5">已驳回</span>
            <span v-else>未知状态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.payStatus === 4"
              size="small"
              class="mx-10"
              @click="handleReviewClick(scope.row)"
              >审核</el-button
            >
            <el-popconfirm title="确定要中止吗？" @confirm="handleStopClick(scope.row)">
              <el-button
                slot="reference"
                v-if="scope.row.serverStatus === 1"
                type="text"
                size="small"
                >中止</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>-->
      </el-table>
      <!-- 实例资源table -->
      <el-table
        v-else-if="activeName === '1'"
        key="1"
        :data="tableData"
        :pagination="pagination"
        border
        style="width: 100%"
      >
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{
              (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="memberName" label="创建人" align="center">
        </el-table-column>
        <el-table-column prop="endDate" label="创建时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.endDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="memberName" align="center" label="用户"> </el-table-column>
        <el-table-column prop="instanceName" align="center" label="申请资源">
        </el-table-column>
        <el-table-column prop="serverStatus" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.serverStatus === 0">已通过</span>
            <span v-else-if="scope.row.serverStatus === 1">已拒绝</span>
            <span v-else-if="scope.row.serverStatus === 2">审核中</span>
            <span v-else>未知状态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.serverStatus === 2"
              size="small"
              class="mx-10"
              @click="handleReviewClick(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 服务接入table -->
      <el-table
        v-else-if="activeName === '2'"
        key="2"
        :data="tableData"
        :pagination="pagination"
        border
        style="width: 100%"
      >
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{
              (pagination.currentPage - 1) * pagination.pageSize + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="memberName" label="创建人" align="center">
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="memberName" align="center" label="用户"> </el-table-column>
        <el-table-column prop="appName" align="center" label="应用名称">
        </el-table-column>
        <el-table-column prop="serverName" align="center" label="应用服务">
          <template slot-scope="scope">
            {{ scope.row.serverName || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="serverStatus" align="center" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.serverStatus === 1">审核中</span>
            <span v-else-if="scope.row.serverStatus === 2">审核未通过</span>
            <span v-else-if="scope.row.serverStatus === 3">（使用中）审核通过</span>
            <span v-else-if="scope.row.serverStatus === 4">已终止</span>
            <span v-else>未知状态</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.serverStatus === 1"
              size="small"
              class="mx-10"
              @click="handleReviewClick(scope.row)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 审核功能 -->
    <el-drawer
      title="审核"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="cancelForm"
    >
      <el-form ref="form" :model="drawerForm" label-width="120px">
        <el-form-item label="实际到账金额">
          <el-input
            v-model="drawerForm.price"
            placeholder="请输入实际到账金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="drawerForm.result">
            <el-radio :label="0">通过</el-radio>
            <el-radio :label="1">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原因" v-if="drawerForm.result === 1">
          <el-input
            type="textarea"
            v-model="drawerForm.reason"
            placeholder="请输入原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="submitReview" :loading="loading">{{
          loading ? "提交中 ..." : "确 定"
        }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getServiceList,
  getResourceList,
  getAppIncomingList,
  getAppList,
  getAppReview,
  getResourceReview,
} from "@/api/operationsManagement";
import moment from "moment";
import { memberTypeDict } from "@/data/constant";
import ComDetail from "@/components/common/comDetail.vue";
export default {
  name: "AdminStaticsResourceApplication",
  components: {
    ComDetail,
  },
  data() {
    return {
      detail: {
        visible: false,
        record: {},
        columns: 2,
        labelStyle: {
          width: "140px",
          textAlign: "right",
        },
      },
      detailCols: [
        {
          label: "用户",
          prop: "memberName",
        },
        {
          label: "用户类型",
          prop: "memberType",
          formatter: (row) => memberTypeDict[row.memberType],
        },
        {
          label: "应用名称",
          prop: "appName",
          formatter: (row) => moment(row.askDate).format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          label: "交易时间",
          prop: "startTime",
          formatter: (row) => moment(row.startTime).format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          label: "服务商",
          prop: "serverName",
        },
        {
          label: "应用价格（元）",
          prop: "appPrice",
        },
        {
          label: "实际到账金额（元）",
          prop: "receiveMoney",
        },
      ],
      activeName: "0",
      drawer: false,
      tableLoading: false,
      formInline: {
        memberName: "",
        serveName: "",
      },
      pagination: {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: "total, prev, pager, next, jumper", // 分页布局
      },
      tableData: [],
      drawerForm: {
        result: 0,
        reason: "",
        price: "",
      },
      record: {},
      loading: false,
    };
  },
  mounted() {
    this.loadData(this.activeName);
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    handleTabs(tab) {
      this.activeName = tab.name;
      this.pagination = {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: "total, prev, pager, next, jumper", // 分页布局
      };
      this.loadData(tab.name);
    },
    cancelForm() {
      this.drawer = false;
      this.drawerForm = {
        result: 0,
        reason: "",
        price: "",
      };
    },
    // 时间转换
    dateFormat(row) {
      return moment(row.startTime).format("YYYY-MM-DD HH:mm:ss");
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.loadData(this.activeName);
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadData(this.activeName);
    },
    handleClick(row) {
      this.detail.visible = true;
      this.detail.record = row;
    },
    // 查看
    onCancel() {
      this.detail.visible = false;
    },
    handleReviewClick(row) {
      this.drawer = true;
      this.record = row;
    },
    onSubmit() {
      this.tableData = [];
      this.pagination = {
        currentPage: 1, // 当前页
        pageSize: 10, // 每页显示条数
        total: 0, // 总条数
        layout: "total, prev, pager, next, jumper", // 分页布局
      };
      this.loadData(this.activeName);
    },
    async submitReview() {
      this.loading = true;
      let method = getAppReview;
      const params = {
        memberId: this.record.memberId,
        result: this.drawerForm.result,
        receiveMoney: Number(this.drawerForm.price),
      };
      if (this.drawerForm.result === 1) {
        params.reason = this.drawerForm.reason;
      }
      if (this.activeName === "0") {
        // 应用开通-审核
        params.appId = this.record.appId;
        (params.openAppId = this.record.openAppId), (params.reviewType = 10);
      } else if (this.activeName === "1") {
        // 实例资源-审核
        method = getResourceReview;
        params.serverInstanceId = this.record.instanceId;
        params.reviewType = 7;
      } else if (this.activeName === "2") {
        // 服务接入-审核
        method = getResourceReview;
        params.appServerId = this.record.appId;
        params.reviewType = 6;
      }
      await method(params)
        .then(() => {
          this.$message.success("审核成功");
          this.drawer = false;
          this.drawerForm = {
            result: 0,
            reason: "",
            price: "",
          };
          this.record = {};
          this.loadData(this.activeName);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async loadData(tab) {
      this.tableLoading = true;
      let method = getAppList;
      const params = {};

      if (tab === "1") {
        if (this.formInline.memberName) {
          params.memberName = this.formInline.memberName;
        }
        method = getResourceList;
      } else if (tab === "2") {
        if (this.formInline.memberName) {
          params.memberName = this.formInline.memberName;
        }
        method = getServiceList;
      } else {
        if (this.formInline.serveName) {
          params.serveName = this.formInline.serveName;
        }
        method = getAppIncomingList;
        params.openVersion = 1;
        params.openType = 1;
      }
      await method({
        pageNo: this.pagination.currentPage - 1,
        pageSize: this.pagination.pageSize,
        ...params,
      }).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data.content;
        this.pagination.total = res.data.totalElements;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.consult-container {
  background: #fff;
  padding: 24px 0;

  .tabs-container {
    padding: 0 16px;
  }

  .search-container {
    padding: 0 16px;
    border-bottom: 1px solid #ebeef5;
  }

  .table-container {
    padding: 16px;
  }

  .pagination-container {
    margin-top: 16px;
    text-align: right;
  }

  .mx-10 {
    margin: 0 10px;
  }

  .drawer-footer {
    text-align: center;
  }
}

::v-deep .el-drawer__body {
  padding: 0 16px;
}
</style>
<style lang="scss">
.el-popconfirm__main {
  margin: 10px 0;
}
</style>
